<template>
  <div v-if="images.length !== 0">
    <div class="pa-0">
      <ShootingTitleType :type="type" :counter="counter" />
      <div class="img-row">
        <div class="img-row-block" v-for="(image, index) in images" :key="index">
          <ShootingGalleryItem :image="image" :url="image.url" :index="index" @toggle-fullscreen="toggleFullscreen" />
        </div>
      </div>
    </div>

    <!-- Fullscreen component outside the loop -->
    <ShootingGalleryItemFullscreen
      v-if="show !== null"
      :images="images"
      :current-index="show"
      @toggle-fullscreen="toggleFullscreen"
    />
  </div>
</template>

<script>
import ShootingGalleryItem from '@/components/shooting/ShootingGalleryItem.vue'
import ShootingGalleryItemFullscreen from '@/components/shooting/ShootingGalleryItemFullscreen.vue'
import ShootingTitleType from '@/components/shooting/ShootingTitleType.vue'

export default {
  name: 'ShootingGalleryByType',
  components: {
    ShootingGalleryItem,
    ShootingGalleryItemFullscreen,
    ShootingTitleType
  },
  props: {
    type: {
      type: String,
      default: ''
    },
    images: {
      type: Array,
      default: () => []
    },
    originalCount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    counter() {
      if (this.type === 'OPTIMIZED') {
        return `${this.images.length}/${this.originalCount}`
      }
      return null
    }
  },
  data() {
    return {
      show: null
    }
  },
  methods: {
    toggleFullscreen(isModalOpen, index) {
      this.show = isModalOpen ? index : null
    }
  }
}
</script>

<style lang="sass" scoped>
.img-row
  display: flex
  flex-wrap: wrap
</style>
